<template>
  <div>
    <img 
      id="imgView" 
      :src="advertVedioViewInfo.imgUrl" 
      style="width: 100%;position:absolute;top:0;left:0;height:100%;" 
      class="thumbnail" 
      v-show="showImage"
    />
    <video 
      id="videoView" 
      src="" 
      style="object-fit: fill;width: 100%;height:100%" 
      volume="true"
      v-show="!showImage"
      ref="videoPlayer"
    ></video>
  </div>
</template>

<script>
import { getAdvertVedioData } from '@/api/common/advertVedioView/advertVedioViewApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AdvertVedioView',
  data() {
    return {
      curr: 0,
      imagePlayTime: 10 * 1000,
      showImage: true,
      advertVedioViewInfo: {
        imgUrl: '',
        notices: '',
        imgsAndVideos: [],
        words: ''
      },
      videoPlayer: null
    }
  },
  mounted() {
    this.initVideoPlayer()
    this.setVideoHeight()
    this.loadAdvertVedioData()
  },
  methods: {
    initVideoPlayer() {
      this.videoPlayer = this.$refs.videoPlayer
      this.videoPlayer.onended = this.handleVideoEnded
    },
    setVideoHeight() {
      const h = document.documentElement.clientHeight
      this.$refs.videoPlayer.style.height = `${h}px`
    },
    async loadAdvertVedioData() {
      const machineCode = this.$route.query.machineCode
      if (!machineCode) {
        this.$message.error('请求参数中未包含设备编码')
        return
      }

      const shopId = getShopId()
      if (!shopId) {
        this.$message.error('请求参数中未包含小区信息')
        return
      }

      try {
        const res = await getAdvertVedioData({
          machineCode,
          shopId
        })
        const advertInfo = this.refreshAdvertActive(res)
        this.startInterval(advertInfo)
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    startInterval(data) {
      this.advertVedioViewInfo.imgsAndVideos = data
      this.handleImgVideoUrl(this.advertVedioViewInfo.imgsAndVideos)
    },
    handleImgVideoUrl(imgsAndVideos) {
      const vList = imgsAndVideos.map(item => `${item.suffix}:${item.url}`)
      const currentItem = vList[this.curr]

      if (currentItem.includes('VIDEO:')) {
        this.showImage = false
        const url = currentItem.replace('VIDEO:', '')
        this.videoPlayer.src = url
        this.videoPlayer.load()
        this.videoPlayer.play()
      } else {
        const url = currentItem.replace('JPEG:', '')
        this.advertVedioViewInfo.imgUrl = url
        this.showImage = true
        
        setTimeout(() => {
          this.curr++
          if (this.curr >= vList.length) {
            this.curr = 0
            this.loadAdvertVedioData()
            return
          }
          this.handleImgVideoUrl(imgsAndVideos)
        }, this.imagePlayTime)
      }
    },
    handleVideoEnded() {
      this.curr++
      if (this.curr >= this.advertVedioViewInfo.imgsAndVideos.length) {
        this.curr = 0
      }
      this.handleImgVideoUrl(this.advertVedioViewInfo.imgsAndVideos)
    },
    refreshAdvertActive(advertInfo) {
      return advertInfo.sort((a, b) => a.seq - b.seq)
    }
  }
}
</script>

<style scoped>
.thumbnail {
  object-fit: cover;
}
</style>